import sync from './sync';

export default {
  sync,
};



// WEBPACK FOOTER //
// ./src/app/services/fiken/index.js